export default __webpack_public_path__ + "static/media/rocket_anim_8.ebdb8eea.png";